import cartPaymentAndShipmentHtml from './cartpaymentandshipment.component.html';
import './cartpaymentandshipment.component.scss';

class CartPaymentAndShipmentController {
    constructor($scope, $timeout, CartService) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.service = CartService;
        this.showCountrySelect = false;
        this.countries = window.countries || ['Polska'];
    }

    $onInit() {
        this.$scope.$watch(
            () => {
                if (!this.service.summary) return null;

                return this.service.summary;
            },
            (newSummary, oldSummary) => {
                if (!newSummary) return;
                if (!this.service.loaded || this.service.loading) return;

                // New cart value -> refresh payments and shipments
                if (!oldSummary || (oldSummary && newSummary.value_of_products_with_discount != oldSummary.value_of_products_with_discount)) {
                    this.service.loadPayments();

                    if (newSummary.payment_id) {
                        this.service.loadShipments();
                    }

                    return;
                }

                if (oldSummary && newSummary.payment_id && newSummary.payment_id != oldSummary.payment_id) {
                    this.service.loadShipments();
                }
            },
            true
        );
    }

    paymentGroupIsNotEmpty(group) {
        const groupPayments = this.service.payments.filter(payment => payment.group_id == group.id);

        return groupPayments.length > 0;
    }

    setPayment(payment) {
        fbq('track', 'AddPaymentInfo', this.service.getCartPropertiesForFbq());

        this.service.setPayment(payment).then(
            () => {
                this.service.loadShipments();
            }
        );
    }

    setShipment(shipment, options = null) {
        this.service.setShipment(shipment, options);
    }

    getCurrentPayment() {
        if (!this.service.summary.payment_id) return null;

        return this.service.payments.filter(payment => payment.id == this.service.summary.payment_id)[0];
    }

    changeCountry() {
        this.service.loadShipments();
    }
}

let cartPaymentAndShipmentComponent = {
    bindings: {},
    template: cartPaymentAndShipmentHtml,
    controller: CartPaymentAndShipmentController
}

export default cartPaymentAndShipmentComponent;